module.exports = __webpack_public_path__ + "img/faro-hotel-2.2d2407b1.jpg";